import {View,Text, TextInput, TouchableOpacity, 
  Animated,
  StyleSheet,
  useWindowDimensions}  from 'react-native';
import {useState, useEffect, useRef} from 'react';
import Ionicons from 'react-native-vector-icons/Ionicons';


function TextInput2(props) {
 var a= props.value;
 var b= a.length
 const [placeholder, setPlaceholder] = useState(props.placeholder);
 const [isFocused, setIsFocused] = useState(false);
 const moveText = useRef(new Animated.Value(0)).current;
 const [label, setLabel] = useState(placeholder);
 const windows=useWindowDimensions()
 const [color, setColor] = useState('#F9BA49');

 function LabelAnimationIn() {
  setPlaceholder('');
  setIsFocused(true);
  moveTextTop();
}

const moveTextTop = () => {
  Animated.timing(moveText, {
    toValue: 1,
    duration: 100,
    useNativeDriver: true,
  }).start();
};

const yVal = moveText.interpolate({
  inputRange: [0, 1],
  outputRange: [1, -3],
});

const animStyle = {
  transform: [
    {
      translateY: yVal,
    },
  ],
};
  return (
         <View
        style={{
          width: '90%',
          height: windows.height*0.5 ,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          marginBottom:30,
          backgroundColor:'transparent',
          maxHeight:210
        }}>
      <View
          style={{
            width: '90%',
            height: '100%',
            backgroundColor: 'transparent',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
  
          {isFocused && 
            <View style={{ alignSelf: 'flex-start', paddingLeft: 10, height:15, width:'100%' }}>
              <Animated.View style={[styles.animatedStyle, animStyle]}>
                <Text
                  style={{
                    fontWeight: '00',
                    fontFamily: 'Optima',
                    color: '#F9BA49',
                    fontSize: 16,
                    marginLeft:7.5,
                  }}
                  color={color}>
                  {label}
                </Text>
              </Animated.View>
            </View>}
            
            <View
            style={{
              width: '100%',
              height: '80%',
              backgroundColor: '#202020',
              borderColor: '#F9BA49',
              borderWidth: 1.5,
              borderRadius: 15,
              alignItems: 'center',
              justifyContent: 'space-evenly',
              shadowColor:'#202020', shadowRadius:7, shadowOpacity:0.75, shadowOffset:{width:12,height:12}
            }}>
           
          
          <TextInput
              style={{
                width: '80%',
                height: '100%',
                fontSize:16,
                fontWeight: 'bold',
                padding: 5,
                fontFamily: 'Optima',
                color:'#F9BA49',
              }}
            placeholderTextColor={'#ac830e'}
            secureTextEntry={false}
            placeholder={props.placeholder}
            onChangeText={props.control}
            value={props.value}
            maxLength={500}
            multiline={true}
            onFocus={() => {
              LabelAnimationIn();
            }}
          />
         
        </View>
        
          <Text
            style={{
              color: color,
              fontSize: 12,
              fontWeight: '500',
              marginRight: 15,
              marginTop: 15,
              alignSelf:'flex-end'
            }}>
           {'Caratteri '}{b}{'/500'}
          </Text>
       
      </View>
      </View>
  );
}
    
    function TextInput1(props) {
    
    const windows = useWindowDimensions();
    const [secure, setSecure] = useState(props.secure);
    const [secureText, setSecureText] = useState(props.secure);
    const [placeholder, setPlaceholder] = useState(props.placeholder);
  
    const [label, setLabel] = useState(placeholder);
  
    const [iconame, setIconame] = useState('');
    const [color, setColor] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const moveText = useRef(new Animated.Value(0)).current;
  
    function SecureView() {
      return secureText ? (
        <Ionicons
          size={24}
          name={'eye-outline'}
          color={'#F9BA49'}
          onPress={() => {
            setSecureText(!secureText);
          }}
          style={{padding:5}}
        />
      ) : (
        <Ionicons
          size={24}
          name={'eye-off-outline'}
          color={'#F9BA49'}
          onPress={() => {
            setSecureText(!secureText);
          }}
          style={{padding:5}}
        />
      );
    }
  
    function LabelAnimationIn() {
      setPlaceholder('');
      setIsFocused(true);
      moveTextTop();
    }
  
    useEffect(() => {
      if (props.validation == undefined) {
        setColor('#F9BA49');
        setIconame('');
      }
      if (props.validation == true) {
        setColor('#78db00');
        setIconame('checkmark-outline');
      }
      if (props.validation == false) {
        setColor('red');
        setIconame('alert-circle-outline');
      }
    }, [props.validation]);
  
    const moveTextTop = () => {
      Animated.timing(moveText, {
        toValue: 1,
        duration: 100,
        useNativeDriver: true,
      }).start();
    };
  
    const yVal = moveText.interpolate({
      inputRange: [0, 1],
      outputRange: [1, -3],
    });
  
    const animStyle = {
      transform: [
        {
          translateY: yVal,
        },
      ],
    };
  
    return (
      <View
        style={{
          width: '90%',
          height: windows.height*0.08 ,
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          marginBottom:30,
          backgroundColor:'transparent'
        }}
        >
  
        <View
          style={{
            width: '90%',
            height: '100%',
            backgroundColor: 'transparent',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
  
          {isFocused && 
            <View style={{ alignSelf: 'flex-start', paddingLeft: 10, height:15, width:'100%' }}>
              <Animated.View style={[styles.animatedStyle, animStyle]}>
                <Text
                  style={{
                    fontWeight: '00',
                    fontFamily: 'Optima',
                    color: '#F9BA49',
                    fontSize: 16,
                    marginLeft:7.5,
                  }}
                  color={color}>
                  {label}
                </Text>
              </Animated.View>
            </View>
        
          }
          <View
            style={{
              width: '100%',
              height: 40,
              backgroundColor: '#202020',
              borderColor: '#F9BA49',
              borderWidth: 1.5,
              borderRadius: 15,
              alignItems: 'center',
              justifyContent: 'space-evenly',
              flexDirection: 'row',
              shadowColor:'#202020', shadowRadius:7, shadowOpacity:0.75, shadowOffset:{width:12,height:12}
            }}>
            <Ionicons size={24} name={props.icon} color={'#F9BA49'} style={{padding:5}} />
            <TextInput
              style={{
                width: '80%',
                height: '50%',
                fontSize:16,
                fontWeight: 'bold',
                padding: 5,
                fontFamily: 'Optima',
                color:'#F9BA49',
              }}
              placeholder={placeholder}
              onFocus={() => {
                LabelAnimationIn();
              }}
              secureTextEntry={secureText}
              value={props.value}
              onChangeText={props.onChangeText}
              autoComplete={props.autoComplete}
              id={props.id}
            />
            {secure ? <SecureView /> : <></>}
          </View>
  
          <View style={{ height: 10, alignSelf: 'flex-start', marginLeft: 10 }}>
            <Text
              style={{
                fontWeight: '600',
                fontFamily: 'Optima',
                marginTop: 5,
                marginLeft:7.5,
                color: color,
                fontSize: 16,
              }}
              color={color}>
              {props.errorText}
            </Text>
          </View>
        </View>
       {iconame? <Ionicons size={24} name={iconame} color={color} style={{alignItems:'center', marginTop:10, marginLeft:10}}/>: <></>}
      </View>
    );
  }






    function TextInput3 (props) {
      const [sec, setSec] = useState(!props.secure);
      const [aswitch, setSwitch] = useState(false);
    
      useEffect(() => {
        setSec(!sec);
      }, [aswitch]);
    
      function Search() {
        return (
          <View
            style={{
              width: '15%',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              borderLeftColor:'#ac830e',
                  borderRadius:10,
                  borderColor:'#202020',
                  borderWidth:1
            }}>
            
              <Ionicons
                size={15}
                color={props.color}
                name={'search'}
                onPress={() => {props.onPress}}
                  
              />
           
            
          </View>
        );
      }
    
      return (
        <View
          style={{
            alignItems: 'center',
            width: '80%',
            height: props.height,
            marginTop: props.marginTop,
            maxHeight:45
          }}>
          <View style={{ width: '100%', height: '100%' }}>
            <Text
              style={{
                color: props.color,
                fontSize: 10,
                fontWeight: 'bold',
                marginLeft: 15,
                marginBottom: 2,
              }}>
              {props.text}{' '}
            </Text>
            <View
              style={{
                width: '100%',
                height: '80%',
                backgroundColor: '#202020',
                alignSelf: 'center',
                borderRadius: 10,
                borderColor: props.color,
                borderWidth: 1,
                shadowColor: '#101010',
                shadowRadius: 5,
                shadowOpacity: 0.75,
                shadowOffset: { width: 10, height: 10 },
                alignItems: 'space-around',
                flexDirection: 'row',
              }}>
              <View
                style={{
                  width: '15%',
                  height: '100%',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRightColor:'#ac830e',
                  borderRadius:10,
                  borderColor:'#202020',
                  borderWidth:1
                }}>
                <Ionicons size={15} color={props.color} name={props.nameicon1} />
              </View>
              <TextInput
                style={{
                  width: '80%',
                  height: '100%',
                  backgroundColor: '#202020',
                  color: props.color,
                  paddingLeft: 10,
                  fontSize: 12,
                  fontWeight: '800',
                  borderRadius: 10,
                }}
                placeholderTextColor={'#ac830e'}
                
                placeholder={props.placeholder}
                onChangeText={props.control}
                value={props.value}
               
              />
              <Search/>
            </View>
          
          </View>
        </View>
      );
    }
    
export { TextInput1, TextInput2, TextInput3}

const styles = StyleSheet.create({
  animatedStyle: {
    zIndex: 10000,
  },
});